import Toast from 'react-bootstrap/Toast';
import styled from 'styled-components';
import { PRIMARY, PRIMARY_LIGHT } from '../../utils/colors';

export const ToastStyled = styled(Toast)`
  position: fixed;
  top: 20px;
  left: 50%;
  z-index: 10000;
  width: 300px;
  transform: translateX(-50%);
  font-family: 'Figtree', 'sans-serif';
`;

export const ToastHeaderStyled = styled(Toast.Header)`
  background-color: ${PRIMARY};
  color: white;
  font-family: 'FigtreeBold', 'sans-serif';
`;